import bootbox from 'bootbox'
import * as toastr from 'toastr'

$(() => {
  $('#container').on('click', '#DDDD .grid-history', function () {

    let url = $(this).data('url')
    let dialog = bootbox.dialog({
      title: Translator.trans('entity_logger.modal_title'),
      message: `<p><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> ${Translator.trans('common.loading')} </p>`,
      backdrop: true,
      onEscape: true,
      className: 'history-modal',
      size: 'large',
      buttons: {
        cancel: {
          label: Translator.trans('common.close'),
          className: 'btn btn-default',
          callback: function () {
            dialog.modal('hide')
          }
        },
      }
    })

    dialog.init(() => {
      $.ajax({
        url: url,
        type: 'GET',
        success: function (result) {
          dialog.find('.bootbox-body').html(result)
        },
        error: function () {
          toastr.error(Translator.trans('global.messages.fetch_problem'))
        }
      })
    })
  })
})
